<template>
  <generic-modal
    size="small"
    :title="$t('course scoring configuration')"
    icon="star"
    image="/images/icons/course_scoring.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form">
        <div class="ui two item top attached tabular menu" ref="tabs">
          <a class="active item" data-tab="general">
            <i class="info icon"></i> {{ $t("general") }}</a
          >
          <a class="item" data-tab="integration">
            <i class="project diagram icon"></i> {{ $t("integration") }}</a
          >
        </div>
        <div class="ui bottom attached active tab segment" data-tab="general">
          <div class="field">
            <label for="">{{ $t("measurement system limit") }}</label>
            <input type="text" name="" v-model="measurement_limit" />
          </div>
        </div>
        <div class="ui bottom attached tab segment" data-tab="integration">
          <div class="field">
            <label for="">{{ $t("course record") }}</label>
            <div class="ui toggle checkbox">
              <input
                type="checkbox"
                name="example"
                v-model="lock_stage_when_record_generated"
              />
              <label>{{
                $t("disable stage scoring when record is generated")
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import { v4 } from "uuid";

export default {
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  data() {
    return {
      measurement_limit: 100,
      lock_stage_when_record_generated: false,
    };
  },
  methods: {
    add_attribute() {
      let attribute = { id: v4(), name: "", type: "" };
      this.attributes.push(attribute);
    },
    remove_attribute(attribute, index) {
      this.attributes.splice(index, 1);
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/course/scoring/do-save-configuration", {
          s: {
            measurement_limit: vm.measurement_limit,
            lock_stage_when_record_generated:
              vm.lock_stage_when_record_generated,
          },
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/course/scoring/do-get-configuration")
      .then((r) => {
        if (r) {
          if (r.measurement_limit) vm.measurement_limit = r.measurement_limit;
          if (r.lock_stage_when_record_generated)
            vm.lock_stage_when_record_generated =
              r.lock_stage_when_record_generated;
          /**
           * Set stored configuration
           */
        }
      })
      .catch((err) => {
        toast(this.$el, "error", err);
      });

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {},
  updated: function() {
    let vm = this;
    this.$nextTick(function() {
      window.jQuery(this.$refs.type).dropdown({
        onChange(value) {
          let index = window.jQuery(this).data("index");
          vm.attributes[index].type = value;
        },
      });
    });
  },
};
</script>
